<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="80" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <el-input v-model="keyword" :placeholder="placeholder" style="width: 244px" @keyup.enter.native="sendEvent">
            <i slot="append" @click="sendEvent" class="el-icon-search"></i>
          </el-input>
        </ElFormItem>
        <drop-autoComplete label="账号" account v-model="accountId"></drop-autoComplete>
        <ElFormItem class="g-pull-right" label="数据时间">
          <DateRangePicker v-model="datetimeByData" style="width: 220px"></DateRangePicker>
        </ElFormItem>
        <ElFormItem class="g-pull-right" label="新建时间">
          <DateRangePicker v-model="datetimeByCreate" style="width: 220px"></DateRangePicker>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import DropAutoComplete from '@/components/dropdown/eldropdown'
import DateRangePicker from '@/components/date-range-picker/index.vue'

export default {
  name: 'planFilter',
  components: { DropAutoComplete, DateRangePicker },
  props: {
    placeholder: {
      type: String
    }
  },
  methods: {
    sendEvent() {
      const [createBeginTime, createEndTime] = this.datetimeByCreate || []
      const [beginTime, endTime] = this.datetimeByData || []
      const params = {
        adAccountId: this.accountId === -1 ? undefined : this.accountId,
        keyword: this.keyword === '' ? undefined : this.keyword,
        beginTime,
        endTime,
        createBeginTime,
        createEndTime
      }
      this.$emit('on-change', params)
    },

    open() {
      this.$router.push({ name: 'smartptomadd' })
    }
  },
  watch: {
    accountId(nVal) {
      this.sendEvent()
    },
    comDateByData(nVal) {
      this.sendEvent()
    },
    comDateByCreate(nVal) {
      this.sendEvent()
    }
  },
  data() {
    return {
      keyword: '',
      accountId: -1,
      comDateByData: [],
      datetimeByCreate: []
    }
  },
  created() {
    // 初始化默认时间
    const { beginTime, endTime } = this.$route.query
    const lastYear = moment().subtract(1, 'years').format('YYYY-MM-DD')
    const today = moment().format('YYYY-MM-DD')
    this.datetimeByData = [beginTime, endTime]
    this.datetimeByCreate = [lastYear, today]
    this.sendEvent()
  }
}
</script>
